"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Can pass a date object or a valid text representation of a date.
 */
exports.default = (date) => {
    const dateObj = new Date(date); // ensure we have a date object
    return Math.floor(dateObj.getTime() / 1000);
};
